import {
  addObj,
  getPage,
  getDetail,
  deleteObj,
} from '@/api/webadminerrorlogserv'

export default {
  state: {
    state_WebAdminErrorLog_AddObjResult: null,
    state_WebAdminErrorLog_GetPageResult: null,
    state_WebAdminErrorLog_GetDetailResult: null,
    state_WebAdminErrorLog_DeleteObjResult: null,
  },
  mutations: {
    SET_WEBADMINERRORLOG_ADDOBJ_RESULT: (state, rst) => {
      state.state_WebAdminErrorLog_AddObjResult = rst;
    },
    SET_WEBADMINERRORLOG_GETPAGE_RESULT: (state, rst) => {
      state.state_WebAdminErrorLog_GetPageResult = rst;
    },
    SET_WEBADMINERRORLOG_GETDETAIL_RESULT: (state, rst) => {
      state.state_WebAdminErrorLog_GetDetailResult = rst;
    },
    SET_WEBADMINERRORLOG_DELETEOBJ_RESULT: (state, rst) => {
      state.state_WebAdminErrorLog_DeleteObjResult = rst;
    },
  },
  actions: {
    WebAdminErrorLogServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBADMINERRORLOG_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBADMINERRORLOG_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WebAdminErrorLogServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBADMINERRORLOG_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBADMINERRORLOG_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WebAdminErrorLogServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBADMINERRORLOG_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBADMINERRORLOG_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WebAdminErrorLogServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBADMINERRORLOG_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBADMINERRORLOG_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_WebAdminErrorLog_AddObjResult: state => {
      return state.state_WebAdminErrorLog_AddObjResult;
    },
    get_WebAdminErrorLog_GetPageResult: state => {
      return state.state_WebAdminErrorLog_GetPageResult;
    },
    get_WebAdminErrorLog_GetDetailResult: state => {
      return state.state_WebAdminErrorLog_GetDetailResult;
    },
    get_WebAdminErrorLog_DeleteObjResult: state => {
      return state.state_WebAdminErrorLog_DeleteObjResult;
    },
  }
}